import React, { Component, createContext } from 'react';
import PropTypes from 'prop-types';
import withContext from '../hoc/withContext';

export const ErrorBoundaryContext = createContext();
export const ErrorBoundaryContextProvider = ErrorBoundaryContext.Provider;
export const ErrorBoundaryContextConsumer = ErrorBoundaryContext.Consumer;
export const withErrorBoundaryContext = withContext(
	ErrorBoundaryContextConsumer
);

class ErrorBoundaryProvider extends Component {
	// this is a global error Boundary for the whole App
	// the errorPathname is to set the pathname that was initially trigger the error
	// after the user click another pathname the `errorPathname` wil be set to
	// null and the apollo client store will be reset this is been done here
	// ErrorBoundaryContext component packages/utils/cp3/context/ErrorBoundaryContext.js

	state = {
		hasError: false,
		error: null,
		errorInfo: null,
		errorPathname: null,
	};

	static propTypes = {
		children: PropTypes.node,
	};

	setErrors = ({
		hasError = false,
		error = null,
		errorInfo = null,
		errorPathname = null,
	}) => {
		this.setState({ hasError, error, errorInfo, errorPathname });
	};

	render() {
		const contextValue = { ...this.state, setErrors: this.setErrors };

		return (
			<ErrorBoundaryContextProvider value={contextValue}>
				{this.props.children}
			</ErrorBoundaryContextProvider>
		);
	}
}

export default ErrorBoundaryProvider;
